/* NANALUZ — interacciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Titulares que entran palabra a palabra ---- */
  function initSplit(root) {
    (root || document).querySelectorAll('[data-nl-split]:not([data-split-done])').forEach(function (el) {
      el.setAttribute('data-split-done', '');
      var i = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (w) {
              if (!w) return;
              if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
              var o = document.createElement('span'); o.className = 'nl-w';
              var s = document.createElement('span'); s.textContent = w; s.style.setProperty('--i', i++);
              o.appendChild(s); frag.appendChild(o);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') { walk(n); }
        });
      }
      walk(el);
      el.classList.add('nl-split');
    });
  }

  /* ---- Aparición al hacer scroll (un único observer) ---- */
  var io;
  function initReveal(root) {
    var els = (root || document).querySelectorAll('.nl-reveal, .nl-reveal--img, .nl-split, [data-nl-observe]');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('nl-visible'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('nl-visible'); io.unobserve(en.target); }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -6% 0px' });
    }
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---- Estrellas ---- */
  function initStars(root) {
    (root || document).querySelectorAll('[data-nl-stars]').forEach(function (box) {
      if (box.childElementCount) return;
      var n = parseInt(box.getAttribute('data-nl-stars'), 10) || 30;
      for (var k = 0; k < n; k++) {
        var s = document.createElement('i'); s.className = 'nl-star';
        s.style.left = (Math.random() * 100) + '%';
        s.style.top = (Math.random() * 100) + '%';
        s.style.setProperty('--s', (1.5 + Math.random() * 2.5).toFixed(1) + 'px');
        s.style.setProperty('--t', (3 + Math.random() * 5).toFixed(1) + 's');
        s.style.setProperty('--dl', (-Math.random() * 6).toFixed(1) + 's');
        box.appendChild(s);
      }
    });
  }

  /* ---- Parallax suave ---- */
  var px = [];
  function initParallax(root) {
    (root || document).querySelectorAll('[data-nl-parallax]').forEach(function (el) { if (px.indexOf(el) < 0) px.push(el); });
  }
  function tick() {
    var vh = window.innerHeight;
    px.forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var f = parseFloat(el.getAttribute('data-nl-parallax')) || 0.15;
      el.style.transform = 'translate3d(0,' + (-r.top * f).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  var ticking = false;
  window.addEventListener('scroll', function () { if (!ticking && !reduce) { ticking = true; requestAnimationFrame(tick); } }, { passive: true });

  /* ---- Brillo que sigue al ratón en botones ---- */
  document.addEventListener('pointermove', function (e) {
    var b = e.target.closest && e.target.closest('.nl-btn');
    if (!b) return;
    var r = b.getBoundingClientRect();
    b.style.setProperty('--mx', (e.clientX - r.left) + 'px');
    b.style.setProperty('--my', (e.clientY - r.top) + 'px');
  });

  /* ---- Tarjetas que se inclinan ---- */
  function initTilt(root) {
    if (reduce || window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('[data-nl-tilt]').forEach(function (c) {
      if (c._tilt) return; c._tilt = true;
      var max = parseFloat(c.getAttribute('data-nl-tilt')) || 6;
      c.addEventListener('pointermove', function (e) {
        var r = c.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        c.style.transform = 'perspective(900px) rotateY(' + (x * max) + 'deg) rotateX(' + (-y * max) + 'deg) translateY(-6px)';
      });
      c.addEventListener('pointerleave', function () { c.style.transform = ''; });
    });
  }

  /* ---- Cifras que cuentan ---- */
  function initCount(root) {
    var els = (root || document).querySelectorAll('[data-nl-count]');
    if (!els.length) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        obs.unobserve(en.target);
        var el = en.target, to = parseFloat(el.getAttribute('data-nl-count')) || 0;
        var dec = (String(to).split('.')[1] || '').length, t0 = null, dur = 1800;
        if (reduce) { el.textContent = to.toLocaleString('es-ES', { minimumFractionDigits: dec }); return; }
        function step(t) {
          if (!t0) t0 = t;
          var p = Math.min((t - t0) / dur, 1), v = to * (1 - Math.pow(1 - p, 4));
          el.textContent = v.toLocaleString('es-ES', { minimumFractionDigits: dec, maximumFractionDigits: dec });
          if (p < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (e) { obs.observe(e); });
  }

  /* ---- Página de producto ---- */
  function money(cents) {
    var fmt = (window.NL && window.NL.moneyFormat) || '{{amount_with_comma_separator}} €';
    var v = (cents / 100).toFixed(2);
    var comma = v.replace('.', ',');
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
      if (k === 'amount_no_decimals' || k === 'amount_no_decimals_with_comma_separator') return Math.round(cents / 100);
      if (k.indexOf('comma') > -1) return comma;
      return v;
    });
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-nl-pdp]').forEach(function (pdp) {
      if (pdp._ok) return; pdp._ok = true;
      var main = pdp.querySelector('.nl-gallery__main');
      var thumbs = Array.prototype.slice.call(pdp.querySelectorAll('.nl-gallery__thumb'));
      var cur = 0;
      function show(i) {
        if (!thumbs.length) return;
        cur = (i + thumbs.length) % thumbs.length;
        var t = thumbs[cur], img = main.querySelector('img');
        thumbs.forEach(function (x) { x.classList.toggle('is-active', x === t); });
        if (img.getAttribute('src') === t.dataset.src) return;
        img.classList.add('is-leaving');
        setTimeout(function () {
          img.src = t.dataset.src; img.srcset = t.dataset.srcset || ''; img.alt = t.dataset.alt || '';
          img.onload = function () { img.classList.remove('is-leaving'); };
          setTimeout(function () { img.classList.remove('is-leaving'); }, 400);
        }, 220);
        t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
      var prev = pdp.querySelector('[data-nl-prev]'), next = pdp.querySelector('[data-nl-next]');
      if (prev) prev.addEventListener('click', function (e) { e.stopPropagation(); show(cur - 1); });
      if (next) next.addEventListener('click', function (e) { e.stopPropagation(); show(cur + 1); });
      if (main && window.matchMedia('(hover: hover)').matches) {
        main.addEventListener('click', function (e) {
          if (e.target.closest('button')) return;
          main.classList.toggle('is-zoom');
        });
        main.addEventListener('pointermove', function (e) {
          if (!main.classList.contains('is-zoom')) return;
          var r = main.getBoundingClientRect();
          main.querySelector('img').style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        });
        main.addEventListener('pointerleave', function () { main.classList.remove('is-zoom'); });
      }
      var touchX = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { touchX = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (touchX === null) return;
          var dx = e.changedTouches[0].clientX - touchX; touchX = null;
          if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1));
        });
      }

      /* variantes */
      var dataEl = pdp.querySelector('[data-nl-variants]');
      var variants = dataEl ? JSON.parse(dataEl.textContent) : [];
      var form = pdp.querySelector('form[data-nl-form]');
      var idInput = form && form.querySelector('input[name="id"]');
      var btn = pdp.querySelector('.nl-buy__add');
      var btnLabel = btn && btn.querySelector('[data-label]');
      var priceNow = pdp.querySelector('[data-nl-price]');
      var priceWas = pdp.querySelector('[data-nl-compare]');
      var save = pdp.querySelector('[data-nl-save]');
      var sticky = document.querySelector('[data-nl-sticky-price]');
      function selected() {
        return Array.prototype.map.call(pdp.querySelectorAll('.nl-buy__opt'), function (fs) {
          var c = fs.querySelector('input:checked'); return c ? c.value : null;
        });
      }
      function update() {
        var sel = selected();
        pdp.querySelectorAll('.nl-buy__opt').forEach(function (fs, i) {
          var lab = fs.querySelector('[data-nl-optval]'); if (lab) lab.textContent = sel[i] || '';
        });
        var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
        if (!v) { if (btn) { btn.disabled = true; btnLabel.textContent = btn.dataset.unavailable; } return; }
        idInput.value = v.id;
        if (priceNow) priceNow.textContent = money(v.price);
        if (sticky) sticky.textContent = money(v.price);
        var onSale = v.compare_at_price && v.compare_at_price > v.price;
        if (priceWas) { priceWas.hidden = !onSale; if (onSale) priceWas.textContent = money(v.compare_at_price); }
        if (save) { save.hidden = !onSale; if (onSale) save.textContent = save.dataset.tpl.replace('[x]', Math.round((1 - v.price / v.compare_at_price) * 100)); }
        if (btn) { btn.disabled = !v.available; btnLabel.textContent = v.available ? btn.dataset.add : btn.dataset.soldout; }
        if (v.featured_media) {
          var i = thumbs.map(function (t) { return t.dataset.mediaId; }).indexOf(String(v.featured_media.id));
          if (i > -1) show(i);
        }
        if (window.history.replaceState && pdp.dataset.url) window.history.replaceState({}, '', pdp.dataset.url + '?variant=' + v.id);
      }
      pdp.querySelectorAll('.nl-buy__opt input').forEach(function (r) { r.addEventListener('change', update); });

      /* cantidad */
      var q = pdp.querySelector('.nl-qty input');
      pdp.querySelectorAll('[data-nl-qty]').forEach(function (b) {
        b.addEventListener('click', function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + parseInt(b.dataset.nlQty, 10)); });
      });

      /* añadir al carrito (abre el carrito lateral de Dawn) */
      if (form) form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!btn || btn.disabled) return;
        var err = pdp.querySelector('.nl-buy__err'); if (err) err.textContent = '';
        btn.classList.add('is-loading'); btnLabel.textContent = '…';
        var drawer = document.querySelector('cart-drawer');
        var body = { items: [{ id: parseInt(idInput.value, 10), quantity: q ? parseInt(q.value, 10) || 1 : 1 }] };
        if (drawer) { body.sections = 'cart-drawer,cart-icon-bubble'; body.sections_url = window.location.pathname; }
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r.json(); }).then(function (res) {
          btn.classList.remove('is-loading');
          if (res.status && res.description && !res.items) {
            btnLabel.textContent = btn.dataset.add;
            if (err) err.textContent = res.description || res.message || 'Error';
            return;
          }
          btn.classList.add('is-done'); btnLabel.textContent = btn.dataset.added;
          setTimeout(function () { btn.classList.remove('is-done'); btnLabel.textContent = btn.dataset.add; }, 2200);
          if (drawer && drawer.renderContents) {
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          } else { window.location.href = (window.routes && window.routes.cart_url) || '/cart'; }
        }).catch(function () {
          btn.classList.remove('is-loading'); btnLabel.textContent = btn.dataset.add;
          form.submit();
        });
      });

      /* barra de compra flotante */
      var bar = document.querySelector('.nl-sticky-buy');
      if (bar && btn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var e = en[0];
          bar.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(btn);
        var sb = bar.querySelector('button');
        if (sb) sb.addEventListener('click', function () { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(function () { btn.click(); }, 500); });
      }
    });
  }

  function initAll(root) {
    initSplit(root); initReveal(root); initStars(root); initParallax(root); initTilt(root); initCount(root); initProduct(root);
    tick();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); }); else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
